import React from 'react';
import {Flex} from "reflexbox";
import {StarOutline} from "@mui/icons-material";
import Chip from "@mui/material/Chip";
import HamburgerMenu from "../common/HamburgerMenu";
import {useSelector} from "react-redux";
import {getTimeAndScore} from "../../helpers/gameUtils";
import Time from "./Timer";
import Box from "@mui/material/Box";
import ReactTourStepper from "./ReactTourStepper";


const InGameHeader = (props) => {
  const questionHistory = useSelector((state) => state.team?.teamDetails?.questions) || {};
  const { pointsFromQs } = getTimeAndScore(questionHistory, props.currentCourse);
  return (<>
    <Flex style={{width: '100%'}}>
      <Box id={'tour1'}>
        <HamburgerMenu currentCourse={props.currentCourse}  chip/>
      </Box>
      <Flex style={{width: '100%', justifyContent: 'flex-end'}}>
        <Chip id={'tour2'} icon={<StarOutline/>} label={pointsFromQs} color="primary" style={{minWidth: '87px', margin: '0 8px'}}/>
        <Box id={'tour3'}><Time id={'tour3'} currentCourse={props.currentCourse} /></Box>
      </Flex>
      <ReactTourStepper />
    </Flex>
  </>)
};

export default InGameHeader;
